import { api, getApiData, sendApiData } from "./client";

export type ClientSession = {
  id?: number;
  email?: string;
  phone?: string | null;
  nickname?: string | null;
  avatarUrl?: string | null;
  plan: string;
  planName?: string;
  groups?: string[];
  planExpiresAt?: string | null;
  onboardingStatus?: string | null;
  token?: string;
};

export type ClientProfilePayload = {
  nickname?: string;
  email?: string;
  avatarDataUrl?: string;
};

export type ClientOnboardingPayload = {
  status: "skipped" | "completed";
  nickname?: string;
  role?: string;
  industry?: string;
  usage?: string;
  inspirations?: string[];
  interests?: string[];
};

export type ClientPasswordPayload = {
  currentPassword: string;
  newPassword: string;
};

export type QrLoginSession = {
  id: string;
  browserKey: string;
  image: string;
  expiresAt: number;
  verificationCode: string;
};

export type QrLoginStatus = {
  status: "pending" | "link_required" | "confirmed" | "consumed";
  expiresAt: number;
  phone?: string;
};

type Envelope<T> = { code: number; data: T; message: string };

async function postAuth<T>(url: string, body: unknown): Promise<T> {
  const payload = (await api.post(url, body)) as Envelope<T>;
  if (payload.code !== 0 && payload.code !== 200)
    throw new Error(payload.message || "请求失败");
  return payload.data;
}

export const clientAuthApi = {
  sendSms: (phone: string, scene: "register" | "login") =>
    postAuth<{ sent: boolean }>("/client/auth/sms", { phone, scene }),
  login: (phone: string, password: string) =>
    postAuth<ClientSession>("/client/auth/login", { phone, password }),
  register: (phone: string, password: string, code: string) =>
    postAuth<ClientSession>("/client/auth/register", { phone, password, code }),
  me: () => getApiData<ClientSession>("/client/auth/me"),
  updateProfile: (data: ClientProfilePayload) =>
    sendApiData<ClientSession>("put", "/client/auth/profile", data, { timeout: 20000 }),
  updatePassword: (data: ClientPasswordPayload) =>
    sendApiData<{ updated: boolean }>("put", "/client/auth/password", data),
  saveOnboarding: (data: ClientOnboardingPayload) =>
    sendApiData<ClientSession>("put", "/client/auth/onboarding", data),
  qrStart: () => sendApiData<QrLoginSession>("post", "/client/auth/qr/start", {}, { timeout: 25000 }),
  qrStatus: (session: QrLoginSession) =>
    sendApiData<QrLoginStatus>("post", "/client/auth/qr/status", { id: session.id, browserKey: session.browserKey }),
  qrLink: (session: QrLoginSession, password: string) =>
    sendApiData<{ status: "confirmed" }>("post", "/client/auth/qr/link", { id: session.id, browserKey: session.browserKey, password }),
  qrConsume: (session: QrLoginSession) =>
    sendApiData<ClientSession>("post", "/client/auth/qr/consume", { id: session.id, browserKey: session.browserKey }),
};
